import { render, staticRenderFns } from "./SaleOrderQuery.vue?vue&type=template&id=55a8c2a2&scoped=true"
import script from "./SaleOrderQuery.vue?vue&type=script&lang=js"
export * from "./SaleOrderQuery.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderQuery.vue?vue&type=style&index=0&id=55a8c2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a8c2a2",
  null
  
)

export default component.exports